import gridImg from 'img/aiTools/grid.png';
import { backgroundColors, backgroundImages } from 'reactApp/appHelpers/featuresHelpers/features/imageTools';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import type { NewBackground, NewBackgroundType } from 'reactApp/modules/aiTools/aiTools.types';

export type ItemType = NewBackground & { backgroundImage?: string; backgroundImageThumb?: string };

const getBackgroundImageById = (id: string, isThumb = false) =>
    `${cdnPackagesUrl}/static/cloud/ai/photo-improving/backs/${id}${isThumb ? '_thumb' : ''}.png`;

const itemsRefs: Record<string, ItemType> = {};

const items: (ItemType | ItemType[])[] = [
    { id: 'transparent', type: 'transparent' as NewBackgroundType, backgroundImageThumb: gridImg },
    [
        ...backgroundColors.map((item) => ({
            id: item.id,
            type: 'color' as NewBackgroundType,
        })),
    ],
    ...backgroundImages.map((item) => ({
        id: item.id,
        type: 'mail' as NewBackgroundType,
        backgroundImage: getBackgroundImageById(item.id),
        backgroundImageThumb: getBackgroundImageById(item.id, true),
    })),
].map((item) => {
    if (!Array.isArray(item)) {
        itemsRefs[item.id] = item;
    } else {
        item.forEach((itemInternal) => {
            itemsRefs[itemInternal.id] = itemInternal;
        });
    }
    return item;
});

export const getItemById = (id: string) => itemsRefs[id];

export const useGetItems = () => items;
